import { useState, useEffect } from "react";
import { Form, Row, Col, Input, Select, DatePicker, Button, Space } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { CashbackReportFilters as CashbackReportFiltersType } from "../hooks/useCashbackReport";
import {
  brandsService,
  productCategoriesService,
} from "../../../shared/services";

const { RangePicker } = DatePicker;
const { Option } = Select;

interface CashbackReportFiltersProps {
  filters: CashbackReportFiltersType;
  onFiltersChange: (filters: Partial<CashbackReportFiltersType>) => void;
  onClearFilters: () => void;
}

export const CashbackReportFilters = ({
  filters,
  onFiltersChange,
  onClearFilters,
}: CashbackReportFiltersProps) => {
  const [form] = Form.useForm();
  const [brands, setBrands] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBrands();
    fetchCategories();
  }, []);

  const fetchBrands = async () => {
    try {
      const response = await brandsService.find({ query: { $limit: 1000 } });
      // Manejar diferentes tipos de respuesta
      const brandsData = Array.isArray(response)
        ? response
        : "data" in response
        ? response.data
        : [];
      setBrands(brandsData || []);
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await productCategoriesService.find({
        query: { $limit: 1000 },
      });
      // Manejar diferentes tipos de respuesta
      const categoriesData = Array.isArray(response)
        ? response
        : "data" in response
        ? response.data
        : [];
      setCategories(categoriesData || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const filters: Partial<CashbackReportFiltersType> = {};

      if (values.brand_id) filters.brand_id = values.brand_id;
      if (values.category_id) filters.category_id = values.category_id;
      if (values.product_status) filters.product_status = values.product_status;
      if (values.product_code) filters.product_code = values.product_code;

      if (values.date_range && values.date_range.length === 2) {
        filters.date_from = values.date_range[0].format("YYYY-MM-DD");
        filters.date_to = values.date_range[1].format("YYYY-MM-DD");
      }

      onFiltersChange(filters);
    } catch (error) {
      console.error("Error in form validation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    form.resetFields();
    onClearFilters();
  };

  return (
    <Form form={form} layout="vertical">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="brand_id" label="Marca">
            <Select
              placeholder="Seleccionar marca"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {brands.map((brand) => (
                <Option key={brand.id} value={brand.id}>
                  {brand.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="category_id" label="Categoría">
            <Select
              placeholder="Seleccionar categoría"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {categories.map((category) => (
                <Option key={category.id} value={category.id}>
                  {category.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="product_status" label="Estado Producto">
            <Select placeholder="Seleccionar estado" allowClear>
              <Option value="activo">Activo</Option>
              <Option value="inactivo">Inactivo</Option>
              <Option value="eliminado">Eliminado</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="product_code" label="Código Producto">
            <Input placeholder="Código del producto" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="date_range" label="Rango de Fechas">
            <RangePicker
              style={{ width: "100%" }}
              placeholder={["Fecha inicio", "Fecha fin"]}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item label=" " style={{ marginBottom: 0 }}>
            <Space>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
                loading={loading}
              >
                Buscar
              </Button>
              <Button icon={<ClearOutlined />} onClick={handleClear}>
                Limpiar
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
